/* Reprise d'un design Zakeke (David, novembre 2026).
   Lien « Reprendre ce design » de l'espace client : /products/oshibori-rafraichissant-personnalisable?variant=<id>&reprise=<doc>.
   Sur la fiche personnalisable, ce fichier lit <doc>.json puis le PNG (ou le SVG) archivé sur admin.oshibori-concept.com/site/zakeke/,
   choisit le packaging, ouvre l'éditeur maison et lui passe le fichier par son entrée « Ajouter un logo » (même chemin qu'un fichier
   choisi par le client), puis « Ajuster à la zone ». Le BAT reste à générer et à valider par le client.
   Aucune modification de l'éditeur (assets/oshibori-designer.js) : on ne s'appuie que sur ses attributs data-dz-*. */
(function () {
  'use strict';
  var BASE = 'https://admin.oshibori-concept.com/site/zakeke/';
  var PREFER = 'png';            // 'png' (fidèle au design Zakeke) ou 'svg' (vectoriel, si présent)
  var COMPLETE_STEPS = ['pack']; // étapes de la fiche cochées d'office ; ajouter 'qty', 'speed' pour afficher tout de suite le panier
  var CONTACT = 'hello@oshibori-concept.com';

  var params; try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var doc = (params.get('reprise') || '').trim();
  if (!doc) return;

  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var waitFor = function (test, timeout, step) {
    var t0 = Date.now();
    return new Promise(function (res, rej) {
      (function tick() {
        var v; try { v = test(); } catch (e) { v = null; }
        if (v) return res(v);
        if (Date.now() - t0 > (timeout || 10000)) return rej(new Error('timeout'));
        setTimeout(tick, step || 100);
      })();
    });
  };
  var abs = function (v) { return !v ? '' : /^https?:\/\//i.test(v) ? v : BASE + String(v).replace(/^\/+/, ''); };
  var keyOf = function (t) { t = String(t || '').toLowerCase(); if (/noir|black/.test(t)) return 'noir'; if (/\bor\b|gold|dor/.test(t)) return 'or'; if (/argent|silver|gris/.test(t)) return 'argent'; return 'blanc'; };

  function run() {
    var root = document.querySelector('[data-osh-designer]');
    var pdp = document.querySelector('[data-osh-pdp]');
    if (!root || !pdp) return;
    var cfg = {}, pdpCfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-dz-config]').textContent); } catch (e) {}
    try { pdpCfg = JSON.parse(pdp.querySelector('[data-pdp-config]').textContent); } catch (e) {}
    var EN = cfg.lang === 'en';
    var T = function (fr, en) { return EN ? en : fr; };

    /* Message sur la fiche (au-dessus de l'étape Packaging) */
    var pageMsg = null;
    var say = function (text, bad) {
      if (!pageMsg) {
        pageMsg = document.createElement('p');
        pageMsg.setAttribute('role', bad ? 'alert' : 'status');
        var host = pdp.querySelector('[data-pdp-step="pack"]') || pdp.querySelector('[data-pdp-buy]');
        if (host && host.parentNode) host.parentNode.insertBefore(pageMsg, host); else pdp.insertBefore(pageMsg, pdp.firstChild);
      }
      pageMsg.className = bad ? 'osh-dz__alert' : 'osh-dz__note';
      pageMsg.style.marginBottom = '12px';
      pageMsg.textContent = text;
      pageMsg.hidden = false;
    };
    var fail = function (extra) {
      say(T('Le fichier de votre design précédent (réf. ' + doc + ') est introuvable. Déposez votre logo dans l’éditeur, ou écrivez-nous à ' + CONTACT + ' en indiquant cette référence : nous le retrouvons pour vous.',
            'The file of your previous design (ref. ' + doc + ') could not be found. Upload your logo in the editor, or write to us at ' + CONTACT + ' with this reference and we will retrieve it for you.') + (extra ? ' ' + extra : ''), true);
    };
    if (!/^[A-Za-z0-9_-]{4,100}$/.test(doc)) return fail();

    var info = {};
    var getJson = fetch(BASE + encodeURIComponent(doc) + '.json', { cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; });

    var getFile = function (kind) {
      var url = kind === 'svg' ? (info.svg === null ? '' : abs(info.svg) || BASE + doc + '.svg') : (abs(info.png) || BASE + doc + '.png');
      if (!url) return Promise.reject(new Error('none'));
      return fetch(url, { mode: 'cors', cache: 'no-cache' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.blob();
      }).then(function (b) {
        if (!b || !b.size) throw new Error('empty');
        if (kind === 'svg') return new File([b], doc + '.svg', { type: 'image/svg+xml' });
        return trimPng(b).then(function (t) { if (!t) throw new Error('blank'); return new File([t], doc + '.png', { type: 'image/png' }); });
      });
    };

    /* PNG Zakeke = toute la zone d'impression : on retire les bords transparents pour que « Ajuster à la zone » porte sur le logo lui-même */
    var trimPng = function (blob) {
      return new Promise(function (res) {
        var url = URL.createObjectURL(blob), im = new Image();
        im.onload = function () {
          try {
            var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement('canvas'); c.width = w; c.height = h;
            var x = c.getContext('2d'); x.drawImage(im, 0, 0);
            var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
            for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) if (d[(y * w + i) * 4 + 3] > 8) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
            URL.revokeObjectURL(url);
            if (x1 < 0) return res(null);
            if (x0 === 0 && y0 === 0 && x1 === w - 1 && y1 === h - 1) return res(blob);
            var o = document.createElement('canvas'); o.width = x1 - x0 + 1; o.height = y1 - y0 + 1;
            o.getContext('2d').drawImage(c, x0, y0, o.width, o.height, 0, 0, o.width, o.height);
            o.toBlob(function (b) { res(b || blob); }, 'image/png');
          } catch (e) { URL.revokeObjectURL(url); res(blob); }
        };
        im.onerror = function () { URL.revokeObjectURL(url); res(null); };
        im.src = url;
      });
    };

    getJson.then(function (j) {
      info = j || {};
      var order = PREFER === 'svg' ? ['svg', 'png'] : ['png', 'svg'];
      return getFile(order[0]).catch(function () { return getFile(order[1]); });
    }).then(function (file) {
      var notes = [];

      /* Packaging : le JSON fait foi ; sinon la variante du lien (?variant=) reste celle rendue par la fiche */
      var pk = String(info.packaging || '');
      if (pk) {
        var want = keyOf(pk.replace(/^\s*\d+\s*gram\w*/i, ''));
        if (/^\s*10\b/.test(pk)) notes.push(T('Votre design a été créé pour le 10 grammes, qui n’est pas proposé en ligne : il est repris sur le 15 grammes (zone 85 × 16 mm). Pour le 10 grammes, écrivez-nous à ' + CONTACT + '.',
                                                'Your design was created for the 10 grams, which is not sold online: it is placed on the 15 grams (85 × 16 mm area). For the 10 grams, write to us at ' + CONTACT + '.'));
        if (want === 'argent') { notes.push(T('Le packaging argent n’est plus proposé en ligne : le packaging blanc est sélectionné.', 'Silver packaging is no longer sold online: white packaging is selected.')); want = 'blanc'; }
        var v = (pdpCfg.variants || []).filter(function (x) { return keyOf(x.title) === want; })[0];
        var btn = v && pdp.querySelector('[data-pdp-variant="' + v.id + '"]');
        if (btn && !btn.disabled && !btn.classList.contains('is-on')) btn.click();
        if (want === 'noir') notes.push(T('Packaging noir : impression blanche uniquement, votre logo est affiché en blanc.', 'Black packaging: white print only, your logo is shown in white.'));
      }
      COMPLETE_STEPS.forEach(function (n) { var b = pdp.querySelector('[data-pdp-step="' + n + '"] [data-pdp-step-next]'); if (b) b.click(); });

      /* Le brouillon local de l'éditeur serait rechargé à l'ouverture et mélangé au design repris : on l'efface */
      try { localStorage.removeItem('oshibori.dz.' + (cfg.handle || 'perso')); } catch (e) {}

      var input = root.querySelector('[data-dz-file]');
      var openBtn = root.querySelector('[data-dz-open]');
      if (!input || !openBtn) return fail();
      var dt = null; try { dt = new DataTransfer(); dt.items.add(file); } catch (e) { dt = null; }
      if (!dt) {
        var a = document.createElement('a'); a.href = URL.createObjectURL(file); a.download = file.name; a.textContent = T('Télécharger mon design', 'Download my design');
        say(T('Votre navigateur ne permet pas de recharger le design automatiquement : téléchargez-le puis déposez-le avec « Ajouter un logo ». ', 'Your browser cannot reload the design automatically: download it, then upload it with “Add a logo”. '));
        pageMsg.appendChild(a);
        return;
      }

      openBtn.click();
      return waitFor(function () { return window.fabric && root.querySelector('.canvas-container'); }, 15000).then(function () { return sleep(150); }).then(function () {
        var list = root.querySelector('[data-dz-layer-list]'), alertEl = root.querySelector('[data-dz-alert]');
        var before = list ? list.children.length : 0;
        input.files = dt.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return waitFor(function () {
          if (alertEl && !alertEl.hidden && alertEl.textContent) return 'error';
          return list && list.children.length > before ? 'ok' : null;
        }, 10000);
      }).then(function (state) {
        if (state === 'error') return; /* l'éditeur affiche déjà son message (format, poids, lecture) */
        var fit = root.querySelector('[data-dz-fit]'); if (fit) fit.click();
        var mm = info.mm && info.mm.length === 2 ? info.mm[0] + ' × ' + info.mm[1] + ' mm' : '';
        var text = T('Design repris de votre commande précédente' + (mm ? ' (zone Zakeke ' + mm + ')' : '') + ', placé à la taille maximale de la zone d’impression 85 × 16 mm. Vérifiez-le, ajustez-le si besoin, puis générez et validez votre nouveau BAT.',
                     'Design reused from your previous order' + (mm ? ' (Zakeke area ' + mm + ')' : '') + ', placed at the maximum size of the 85 × 16 mm print area. Check it, adjust it if needed, then generate and approve your new proof.');
        if (COMPLETE_STEPS.indexOf('qty') < 0) text += T(' Après le BAT, choisissez la quantité et le délai.', ' After the proof, choose the quantity and lead time.');
        var note = root.querySelector('[data-osh-reprise-note]');
        if (!note) {
          note = document.createElement('p'); note.className = 'osh-dz__note'; note.setAttribute('data-osh-reprise-note', '');
          var a2 = root.querySelector('[data-dz-alert]'); if (a2 && a2.parentNode) a2.parentNode.insertBefore(note, a2.nextSibling);
        }
        note.textContent = text + (notes.length ? ' ' + notes.join(' ') : '');
        if (notes.length) say(notes.join(' '));
        try { var u = new URL(window.location.href); u.searchParams.delete('reprise'); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
      }).catch(function () {
        say(T('Votre design est prêt mais l’éditeur ne s’est pas ouvert. Rechargez la page ou écrivez-nous à ' + CONTACT + ' (réf. ' + doc + ').',
              'Your design is ready but the editor did not open. Reload the page or write to us at ' + CONTACT + ' (ref. ' + doc + ').'), true);
      });
    }).catch(function () { fail(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
